module.exports = __webpack_public_path__ + "img/sertificate.d802d8ca.jpg";